<template>
    <v-row justify="center" class="d-flex align-center align-content-center w-100" no-gutters>
      <div class="dot" :style="{ backgroundColor: color }"></div>
      <span class="text-center">{{ labelText }}</span>
    </v-row>
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
      default: 'Status',
    },
    color: {
      type: String,
      default: 'black',
    }
  }};
</script>

<style scoped>
.dot {
  width: 10px; /* Size of the dot */
  height: 10px; /* Size of the dot */
  border-radius: 50%; /* Makes it a circle */
  flex-shrink: 0; /* Prevents the dot from shrinking */
  margin-right: 6px; /* Spacing between dot and text */
  align-content: center; /* Centers the dot vertically */
}
</style>